// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","socialIcons":"Footer_socialIcons__RhpXs","scrollTop":"Footer_scrollTop__BRw85","copyText":"Footer_copyText__ANXYD"};